export const SET_DEVICE = `SET_DEVICE`;